export const CASE_TYPE_FIELD_OPTIONS = {
  issue: { label: 'Issue', value: 'Issue' },
  enhancementRequest: {
    label: 'Enhancement Request',
    value: 'Enhancement Request',
  },
  serviceRequest: { label: 'Service Request', value: 'Service Request' },
} as const;

// Using variable with type annotation as substitute for satisfies keywork (not
// yet available in version of TypeScript we are using).
/* eslint-disable @typescript-eslint/no-unused-vars */
const typeCheck: Record<string, { label: string; value: string }> =
  CASE_TYPE_FIELD_OPTIONS;
/* eslint-enable @typescript-eslint/no-unused-vars */
